import http from "@/helper/http";
import api from "@/helper/api";

export default {
  state: {
    // RRA EBM Settings
    rraEbmSettings: null,
    loadingRraEbmSettings: false,
    errorRraEbmSettings: null,
    // Update RRA EBM Settings
    updateRraEbmSettings: null,
    loadingUpdateRraEbmSettings: false,
    errorUpdateRraEbmSettings: null,
    // RRA EBM Settings Change Requests
    rraEbmSettingsChangeRequests: null,
    loadingRraEbmSettingsChangeRequests: false,
    errorRraEbmSettingsChangeRequests: null,
    // Store Details Change Requests
    storeDetailsChangeRequests: null,
    loadingStoreDetailsChangeRequests: false,
    errorStoreDetailsChangeRequests: null,
    // Request to Change Store Details
    requestToChangeStoreDetails: null,
    loadingRequestToChangeStoreDetails: false,
    errorRequestToChangeStoreDetails: null,
    // Request to Change RRA EBM Settings
    requestToChangeRraEbmSettings: null,
    loadingRequestToChangeRraEbmSettings: false,
    errorRequestToChangeRraEbmSettings: null,
    // Review RRA EBM Requests
    reviewRraEbmRequests: null,
    loadingReviewRraEbmRequests: false,
    errorReviewRraEbmRequests: null,
    // Review Store Details Change Requests
    reviewStoreDetailsChangeRequests: null,
    loadingReviewStoreDetailsChangeRequests: false,
    errorReviewStoreDetailsChangeRequests: null,
    // EBM Transactions
    ebmTransactions: null,
    loadingEbmTransactions: false,
    errorEbmTransactions: null,
    ebmTransactionDetails: null,
    loadingEbmTransactionDetails: false,
    errorEbmTransactionDetails: null,
    ebmTransactionStats: null,
    loadingEbmTransactionStats: false,
    errorEbmTransactionStats: null,
  },
  mutations: {
    // RRA EBM Settings
    SET_RRA_EBM_SETTINGS(state, settings) {
      state.rraEbmSettings = settings;
    },
    SET_LOADING_RRA_EBM_SETTINGS(state, loading) {
      state.loadingRraEbmSettings = loading;
    },
    SET_ERROR_RRA_EBM_SETTINGS(state, error) {
      state.errorRraEbmSettings = error;
    },
    // Update RRA EBM Settings
    SET_UPDATE_RRA_EBM_SETTINGS(state, settings) {
      state.updateRraEbmSettings = settings;
    },
    SET_LOADING_UPDATE_RRA_EBM_SETTINGS(state, loading) {
      state.loadingUpdateRraEbmSettings = loading;
    },
    SET_ERROR_UPDATE_RRA_EBM_SETTINGS(state, error) {
      state.errorUpdateRraEbmSettings = error;
    },
    // RRA EBM Settings Change Requests
    SET_RRA_EBM_SETTINGS_CHANGE_REQUESTS(state, requests) {
      state.rraEbmSettingsChangeRequests = requests;
    },
    SET_LOADING_RRA_EBM_SETTINGS_CHANGE_REQUESTS(state, loading) {
      state.loadingRraEbmSettingsChangeRequests = loading;
    },
    SET_ERROR_RRA_EBM_SETTINGS_CHANGE_REQUESTS(state, error) {
      state.errorRraEbmSettingsChangeRequests = error;
    },
    // Store Details Change Requests
    SET_STORE_DETAILS_CHANGE_REQUESTS(state, requests) {
      state.storeDetailsChangeRequests = requests;
    },
    SET_LOADING_STORE_DETAILS_CHANGE_REQUESTS(state, loading) {
      state.loadingStoreDetailsChangeRequests = loading;
    },
    SET_ERROR_STORE_DETAILS_CHANGE_REQUESTS(state, error) {
      state.errorStoreDetailsChangeRequests = error;
    },
    // Request to Change Store Details
    SET_REQUEST_TO_CHANGE_STORE_DETAILS(state, request) {
      state.requestToChangeStoreDetails = request;
    },
    SET_LOADING_REQUEST_TO_CHANGE_STORE_DETAILS(state, loading) {
      state.loadingRequestToChangeStoreDetails = loading;
    },
    SET_ERROR_REQUEST_TO_CHANGE_STORE_DETAILS(state, error) {
      state.errorRequestToChangeStoreDetails = error;
    },
    // Request to Change RRA EBM Settings
    SET_REQUEST_TO_CHANGE_RRA_EBM_SETTINGS(state, request) {
      state.requestToChangeRraEbmSettings = request;
    },
    SET_LOADING_REQUEST_TO_CHANGE_RRA_EBM_SETTINGS(state, loading) {
      state.loadingRequestToChangeRraEbmSettings = loading;
    },
    SET_ERROR_REQUEST_TO_CHANGE_RRA_EBM_SETTINGS(state, error) {
      state.errorRequestToChangeRraEbmSettings = error;
    },
    // Review RRA EBM Requests
    SET_REVIEW_RRA_EBM_REQUESTS(state, requests) {
      state.reviewRraEbmRequests = requests;
    },
    SET_LOADING_REVIEW_RRA_EBM_REQUESTS(state, loading) {
      state.loadingReviewRraEbmRequests = loading;
    },
    SET_ERROR_REVIEW_RRA_EBM_REQUESTS(state, error) {
      state.errorReviewRraEbmRequests = error;
    },
    // Review Store Details Change Requests
    SET_REVIEW_STORE_DETAILS_CHANGE_REQUESTS(state, requests) {
      state.reviewStoreDetailsChangeRequests = requests;
    },
    SET_LOADING_REVIEW_STORE_DETAILS_CHANGE_REQUESTS(state, loading) {
      state.loadingReviewStoreDetailsChangeRequests = loading;
    },
    SET_ERROR_REVIEW_STORE_DETAILS_CHANGE_REQUESTS(state, error) {
      state.errorReviewStoreDetailsChangeRequests = error;
    },
    // EBM Transactions
    SET_EBM_TRANSACTIONS(state, transactions) {
      state.ebmTransactions = transactions;
    },
    SET_LOADING_EBM_TRANSACTIONS(state, loading) {
      state.loadingEbmTransactions = loading;
    },
    SET_ERROR_EBM_TRANSACTIONS(state, error) {
      state.errorEbmTransactions = error;
    },
    SET_EBM_TRANSACTION_DETAILS(state, details) {
      state.ebmTransactionDetails = details;
    },
    SET_LOADING_EBM_TRANSACTION_DETAILS(state, loading) {
      state.loadingEbmTransactionDetails = loading;
    },
    SET_ERROR_EBM_TRANSACTION_DETAILS(state, error) {
      state.errorEbmTransactionDetails = error;
    },
    SET_EBM_TRANSACTION_STATS(state, stats) {
      state.ebmTransactionStats = stats;
    },
    SET_LOADING_EBM_TRANSACTION_STATS(state, loading) {
      state.loadingEbmTransactionStats = loading;
    },
    SET_ERROR_EBM_TRANSACTION_STATS(state, error) {
      state.errorEbmTransactionStats = error;
    },
  },
  actions: {
    getRraEbmSettings({ commit }, storeId) {
      commit("SET_LOADING_RRA_EBM_SETTINGS", true);
      // Reset state while fetching to avoid leaking previous store values
      commit("SET_RRA_EBM_SETTINGS", null);
      commit("SET_ERROR_RRA_EBM_SETTINGS", null);
      return new Promise((resolve, reject) => {
        http
          .get(`${api.rra_ebm_settings}/${storeId}`)
          .then((response) => {
            // Check if the response contains an error message
            if (
              response.data &&
              response.data.message &&
              response.data.message.includes("not found")
            ) {
              commit("SET_RRA_EBM_SETTINGS", null);
              commit("SET_LOADING_RRA_EBM_SETTINGS", false);
              commit("SET_ERROR_RRA_EBM_SETTINGS", {
                message: response.data.message,
              });
              reject(new Error(response.data.message));
            } else {
              // Valid response
              commit("SET_RRA_EBM_SETTINGS", response.data);
              commit("SET_LOADING_RRA_EBM_SETTINGS", false);
              commit("SET_ERROR_RRA_EBM_SETTINGS", null);
              resolve(response.data);
            }
          })
          .catch((error) => {
            const status = error?.response?.status;
            if (status === 404) {
              commit("SET_RRA_EBM_SETTINGS", null);
              commit("SET_ERROR_RRA_EBM_SETTINGS", null);
              commit("SET_LOADING_RRA_EBM_SETTINGS", false);
              resolve(null);
              return;
            }
            if (status === 401) {
              commit("SET_RRA_EBM_SETTINGS", null);
              commit("SET_ERROR_RRA_EBM_SETTINGS", null);
              commit("SET_LOADING_RRA_EBM_SETTINGS", false);
              resolve(null);
              return;
            }
            commit("SET_RRA_EBM_SETTINGS", null);
            commit(
              "SET_ERROR_RRA_EBM_SETTINGS",
              error?.response?.data ?? error
            );
            commit("SET_LOADING_RRA_EBM_SETTINGS", false);
            commit("SET_ERROR_RRA_EBM_SETTINGS", error);
            reject(error);
          });
      });
    },
    updateRraEbmSettings({ commit }, updateData) {
      commit("SET_LOADING_UPDATE_RRA_EBM_SETTINGS", true);
      return new Promise((resolve, reject) => {
        http
          .patch(`${api.rra_ebm_settings}`, updateData)
          .then((response) => {
            commit("SET_UPDATE_RRA_EBM_SETTINGS", response.data);
            commit("SET_LOADING_UPDATE_RRA_EBM_SETTINGS", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_LOADING_UPDATE_RRA_EBM_SETTINGS", false);
            reject(error);
          });
      });
    },
    getRraEbmSettingsChangeRequests({ commit }, params = {}) {
      commit("SET_LOADING_RRA_EBM_SETTINGS_CHANGE_REQUESTS", true);
      return new Promise((resolve, reject) => {
        const searchParams = new URLSearchParams({
          page: String(params.page ?? 1),
          per_page: String(params.per_page ?? 10),
          query: params.query ?? "",
        });
        if (params.storeId) {
          searchParams.set("store_id", String(params.storeId));
        }

        http
          .get(
            `${api.rra_ebm_settings_change_requests}?${searchParams.toString()}`
          )
          .then((response) => {
            commit("SET_RRA_EBM_SETTINGS_CHANGE_REQUESTS", response.data);
            commit("SET_LOADING_RRA_EBM_SETTINGS_CHANGE_REQUESTS", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_LOADING_RRA_EBM_SETTINGS_CHANGE_REQUESTS", false);
            reject(error);
          });
      });
    },
    getStoreDetailsChangeRequests({ commit }, params = {}) {
      commit("SET_LOADING_STORE_DETAILS_CHANGE_REQUESTS", true);
      return new Promise((resolve, reject) => {
        const searchParams = new URLSearchParams({
          page: String(params.page ?? 1),
          per_page: String(params.per_page ?? 10),
          query: params.query ?? "",
        });
        if (params.storeId) {
          searchParams.set("store_id", String(params.storeId));
        }

        http
          .get(
            `${api.store_details_change_requests}?${searchParams.toString()}`
          )
          .then((response) => {
            commit("SET_STORE_DETAILS_CHANGE_REQUESTS", response.data);
            commit("SET_LOADING_STORE_DETAILS_CHANGE_REQUESTS", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_LOADING_STORE_DETAILS_CHANGE_REQUESTS", false);
            reject(error);
          });
      });
    },
    requestToChangeStoreDetails({ commit }, payload) {
      commit("SET_LOADING_REQUEST_TO_CHANGE_STORE_DETAILS", true);
      return new Promise((resolve, reject) => {
        http
          .post(
            `${api.store_v1}/${payload.storeId}/details/change/request`,
            payload.data,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            commit("SET_REQUEST_TO_CHANGE_STORE_DETAILS", response.data);
            commit("SET_LOADING_REQUEST_TO_CHANGE_STORE_DETAILS", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_LOADING_REQUEST_TO_CHANGE_STORE_DETAILS", false);
            reject(error);
          });
      });
    },
    requestToChangeRraEbmSettings({ commit }, payload) {
      commit("SET_LOADING_REQUEST_TO_CHANGE_RRA_EBM_SETTINGS", true);
      return new Promise((resolve, reject) => {
        http
          .post(
            `${api.store_v1_ebm}/${payload.storeId}/settings/change/requests`,
            payload.data,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            commit("SET_REQUEST_TO_CHANGE_RRA_EBM_SETTINGS", response.data);
            commit("SET_LOADING_REQUEST_TO_CHANGE_RRA_EBM_SETTINGS", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_LOADING_REQUEST_TO_CHANGE_RRA_EBM_SETTINGS", false);
            reject(error);
          });
      });
    },
    reviewRraEbmRequests({ commit }, payload) {
      commit("SET_LOADING_REVIEW_RRA_EBM_REQUESTS", true);
      return new Promise((resolve, reject) => {
        http
          .patch(
            `${api.review_rra_ebm_requests(payload.requestId)}`,
            payload.data
          )
          .then((response) => {
            commit("SET_REVIEW_RRA_EBM_REQUESTS", response.data);
            commit("SET_LOADING_REVIEW_RRA_EBM_REQUESTS", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_LOADING_REVIEW_RRA_EBM_REQUESTS", false);
            reject(error);
          });
      });
    },
    reviewStoreDetailsChangeRequests({ commit }, payload) {
      commit("SET_LOADING_REVIEW_STORE_DETAILS_CHANGE_REQUESTS", true);
      return new Promise((resolve, reject) => {
        http
          .patch(
            `${api.review_store_details_change_requests(payload.requestId)}`,
            payload.data
          )
          .then((response) => {
            commit("SET_REVIEW_STORE_DETAILS_CHANGE_REQUESTS", response.data);
            commit("SET_LOADING_REVIEW_STORE_DETAILS_CHANGE_REQUESTS", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_LOADING_REVIEW_STORE_DETAILS_CHANGE_REQUESTS", false);
            reject(error);
          });
      });
    },
    // EBM Transactions Actions
    getEbmTransactions({ commit }, params = {}) {
      commit("SET_LOADING_EBM_TRANSACTIONS", true);
      commit("SET_ERROR_EBM_TRANSACTIONS", null);
      return new Promise((resolve, reject) => {
        const searchParams = new URLSearchParams();

        // Add required store_id
        if (params.storeId) {
          searchParams.set("store_id", String(params.storeId));
        }

        // Add optional filters
        if (params.status) {
          searchParams.set("status", params.status);
        }
        if (params.transaction_type) {
          searchParams.set("transaction_type", params.transaction_type);
        }
        if (params.search) {
          searchParams.set("search", params.search);
        }

        // Add pagination
        if (params.page) {
          searchParams.set("page", String(params.page));
        }
        if (params.per_page) {
          searchParams.set("per_page", String(params.per_page));
        } else if (params.limit) {
          // Fallback to limit for backward compatibility
          searchParams.set("per_page", String(params.limit));
        }

        http
          .get(
            `${api.store_transactions(
              params.storeId
            )}?${searchParams.toString()}`
          )
          .then((response) => {
            commit("SET_EBM_TRANSACTIONS", response.data);
            commit("SET_LOADING_EBM_TRANSACTIONS", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit(
              "SET_ERROR_EBM_TRANSACTIONS",
              error?.response?.data ?? error
            );
            commit("SET_LOADING_EBM_TRANSACTIONS", false);
            reject(error);
          });
      });
    },
    getEbmTransactionDetails({ commit }, uuid) {
      commit("SET_LOADING_EBM_TRANSACTION_DETAILS", true);
      commit("SET_ERROR_EBM_TRANSACTION_DETAILS", null);
      return new Promise((resolve, reject) => {
        http
          .get(api.ebm_transaction_details(uuid))
          .then((response) => {
            commit("SET_EBM_TRANSACTION_DETAILS", response.data);
            commit("SET_LOADING_EBM_TRANSACTION_DETAILS", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit(
              "SET_ERROR_EBM_TRANSACTION_DETAILS",
              error?.response?.data ?? error
            );
            commit("SET_LOADING_EBM_TRANSACTION_DETAILS", false);
            reject(error);
          });
      });
    },
    retryEbmTransaction(_, uuid) {
      return new Promise((resolve, reject) => {
        http
          .post(api.ebm_transaction_retry(uuid))
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    retryAllFailedEbmTransactions(_, storeId) {
      return new Promise((resolve, reject) => {
        http
          .post(api.store_transactions_retry_all(storeId), {
            store_id: storeId,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateEbmTransactionRetriable(_, { uuid, isRetriable }) {
      return new Promise((resolve, reject) => {
        http
          .patch(api.ebm_transaction_retriable(uuid), {
            is_retriable: isRetriable,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getEbmTransactionStats({ commit }, storeId) {
      commit("SET_LOADING_EBM_TRANSACTION_STATS", true);
      commit("SET_ERROR_EBM_TRANSACTION_STATS", null);
      return new Promise((resolve, reject) => {
        const searchParams = new URLSearchParams();
        if (storeId) {
          searchParams.set("store_id", String(storeId));
        }

        http
          .get(
            `${api.store_transactions_stats(
              storeId
            )}?${searchParams.toString()}`
          )
          .then((response) => {
            commit("SET_EBM_TRANSACTION_STATS", response.data);
            commit("SET_LOADING_EBM_TRANSACTION_STATS", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit(
              "SET_ERROR_EBM_TRANSACTION_STATS",
              error?.response?.data ?? error
            );
            commit("SET_LOADING_EBM_TRANSACTION_STATS", false);
            reject(error);
          });
      });
    },
  },
  getters: {
    // RRA EBM Settings
    rraEbmSettings: (state) => state.rraEbmSettings,
    loadingRraEbmSettings: (state) => state.loadingRraEbmSettings,
    errorRraEbmSettings: (state) => state.errorRraEbmSettings,
    // Update RRA EBM Settings
    updateRraEbmSettings: (state) => state.updateRraEbmSettings,
    loadingUpdateRraEbmSettings: (state) => state.loadingUpdateRraEbmSettings,
    errorUpdateRraEbmSettings: (state) => state.errorUpdateRraEbmSettings,
    // RRA EBM Settings Change Requests
    rraEbmSettingsChangeRequests: (state) => state.rraEbmSettingsChangeRequests,
    loadingRraEbmSettingsChangeRequests: (state) =>
      state.loadingRraEbmSettingsChangeRequests,
    errorRraEbmSettingsChangeRequests: (state) =>
      state.errorRraEbmSettingsChangeRequests,
    // Store Details Change Requests
    storeDetailsChangeRequests: (state) => state.storeDetailsChangeRequests,
    loadingStoreDetailsChangeRequests: (state) =>
      state.loadingStoreDetailsChangeRequests,
    errorStoreDetailsChangeRequests: (state) =>
      state.errorStoreDetailsChangeRequests,
    // Request to Change Store Details
    requestToChangeStoreDetails: (state) => state.requestToChangeStoreDetails,
    loadingRequestToChangeStoreDetails: (state) =>
      state.loadingRequestToChangeStoreDetails,
    errorRequestToChangeStoreDetails: (state) =>
      state.errorRequestToChangeStoreDetails,
    // Request to Change RRA EBM Settings
    requestToChangeRraEbmSettings: (state) =>
      state.requestToChangeRraEbmSettings,
    loadingRequestToChangeRraEbmSettings: (state) =>
      state.loadingRequestToChangeRraEbmSettings,
    errorRequestToChangeRraEbmSettings: (state) =>
      state.errorRequestToChangeRraEbmSettings,
    // Review RRA EBM Requests
    reviewRraEbmRequests: (state) => state.reviewRraEbmRequests,
    loadingReviewRraEbmRequests: (state) => state.loadingReviewRraEbmRequests,
    errorReviewRraEbmRequests: (state) => state.errorReviewRraEbmRequests,
    // Review Store Details Change Requests
    reviewStoreDetailsChangeRequests: (state) =>
      state.reviewStoreDetailsChangeRequests,
    loadingReviewStoreDetailsChangeRequests: (state) =>
      state.loadingReviewStoreDetailsChangeRequests,
    errorReviewStoreDetailsChangeRequests: (state) =>
      state.errorReviewStoreDetailsChangeRequests,
    // EBM Transactions
    ebmTransactions: (state) => state.ebmTransactions,
    loadingEbmTransactions: (state) => state.loadingEbmTransactions,
    errorEbmTransactions: (state) => state.errorEbmTransactions,
    ebmTransactionDetails: (state) => state.ebmTransactionDetails,
    loadingEbmTransactionDetails: (state) => state.loadingEbmTransactionDetails,
    errorEbmTransactionDetails: (state) => state.errorEbmTransactionDetails,
    ebmTransactionStats: (state) => state.ebmTransactionStats,
    loadingEbmTransactionStats: (state) => state.loadingEbmTransactionStats,
    errorEbmTransactionStats: (state) => state.errorEbmTransactionStats,
  },
};
